import React, { useEffect, useState } from "react";
import { Form, Button, CloseButton } from "react-bootstrap";
import { message } from "antd";
import { UserAuth } from "../Context";
import { saveInviteToDb } from "../lib/saveInviteToDb";
import { checkIfEmailExists } from "../lib/checkIfEmailExists";
import { Link } from "react-router-dom";
import referralLink from "../lib/referralLink";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { ShareFooter } from "./ShareTray/ShareFooter";
const { InviteUser } = require("../EmailSystem/sendEmails");

const InviteToLookflock = ({ closeTray }) => {
  const [referralCode, setReferralCode] = useState("");
  const data = referralLink(referralCode);
  const [Error, setError] = useState("");
  const { user } = UserAuth();
  const [emailUsers, setEmailUsers] = useState([]);
  const [emailInputValue, setEmailInputValue] = useState("");
  const text = "Invite Friends";
  const myEmail = user?.providerData[0].email;

  const [inviteOption, setInviteOption] = useState("email");

  useEffect(() => {
    if (!user) return;
    const fetchReferralCode = async () => {
      try {
        const userDocRef = doc(db, "users", user?.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();
          if (userData && userData.referralCode) {
            setReferralCode(userData.referralCode);
          }
        }
      } catch (error) {
        console.error("Error fetching referral code:", error);
      }
    };

    fetchReferralCode();
  }, [user]);

  const checkEmails = async (email) => {
    if (email === myEmail) {
      setError("Cannot email yourself");
      return false; // Email is same as user's email
    }
    if (emailUsers.includes(email)) {
      setError("Emails should be unique");
      return false; // Duplicate found
    }
    const emailExists = await checkIfEmailExists(email);
    if (emailExists.exists) {
      const handleLinkClick = () => {
        closeTray(); // Close the modal when the link is clicked
      };

      const userLink = (
        <Link
          to={`/userProfile/${emailExists.userId}`}
          onClick={handleLinkClick}
        >
          {emailExists.firstName}
        </Link>
      );

      // Set the error state with the clickable link
      setError(
        <>
          {email} is already on Lookflock. Add {userLink} and invite them
          directly.
        </>
      );

      return false;
    }
    return true;
  };
  const onEmailFinish = async (values) => {
    if (values.length === 0) {
      if (isValidEmail(emailInputValue)) {
        if (await checkEmails(emailInputValue)) {
          values.push(emailInputValue);
        }
      } else {
        setError("Please enter a valid email");
        return;
      }
    }
    values.forEach(async (email) => {
      // console.log(user, data);
      InviteUser(user?.displayName, email, data)
        .then(() => {
          message.success({
            content: `Email sent successfully to ${email}`,
            key: "success",
          });
        })
        .catch((error) => {
          message.error(`Error sending email to ${email}`);
          console.error("Error sending email:", error);
        });

      closeTray();
      await saveInviteToDb(
        {
          name: "",
          email,
          type: "email",
        },
        user
      );
    });
  };

  const handleCopyLink = () => {
    const fullLink = data.replace(
      "http://localhost:3000",
      "https://lookflock.com"
    );
    navigator.clipboard.writeText(fullLink); // Copy link to clipboard
    message.success({
      content: `Link copied`,
      key: "success",
    });
  };

  const handleFacebookShare = () => {
    const shareQuote = encodeURIComponent(text);
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=https://lookflock.com/#/ProductDetails/${text}&quote=${shareQuote}`
    );
  };

  const handleWhatsappShare = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `${text}: ${data}`
      )}`
    );
  };

  const handleEmailChange = (e) => {
    setError("");
    setEmailInputValue(e.target.value);
  };

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleKeyDown = async (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      const trimmed = emailInputValue.trim().replace(/,$/, "");
      if (
        trimmed &&
        isValidEmail(trimmed) &&
        (await checkEmails(e.target.value))
      ) {
        if (!emailUsers.includes(trimmed)) {
          setEmailUsers([...emailUsers, trimmed]);
        }
        setEmailInputValue("");
      }
    }
  };

  const removeEmail = (removeIndex) => {
    setEmailUsers(emailUsers.filter((_, index) => index !== removeIndex));
  };
  return (
    <div>
      <div className="d-flex align-items-center" style={{ gap: "60px" }}>
        <div
          onClick={() => setInviteOption("email")}
          className="linkStyle"
          style={{
            borderBottom:
              inviteOption === "email" ? `1px solid rgb(0, 95, 218)` : "",
            color: inviteOption === "email" ? "#005FDA" : "#667085",
            fontSize: "14px",
            fontWeight: 500,
            margin: 0,
            cursor: "pointer",
          }}
        >
          Email
        </div>
      </div>
      <div className="mt-2 d-flex flex-column gap-3">
        <Form
          className="d-flex flex-column gap-2"
          onSubmit={async (e) => {
            e.preventDefault();
            onEmailFinish(emailUsers);
          }}
        >
          <div>
            {emailUsers.length > 0 && (
              <div
                className="d-flex align-items-center gap-2 mb-2"
                style={{
                  overflowX: "auto",
                  scrollbarWidth: "thin",
                  paddingBottom: "4px",
                }}
              >
                {emailUsers.map((email, index) => (
                  <Button
                    key={index}
                    size="sm"
                    variant="primary-soft"
                    className="d-flex align-items-center"
                  >
                    {email}
                    <CloseButton
                      className="ms-2"
                      onClick={() => removeEmail(index)}
                    />
                  </Button>
                ))}
              </div>
            )}
            <div className="d-flex gap-2 align-items-center">
              <Form.Control
                type="text"
                placeholder="email@example.com"
                className="rounded-2 h-50"
                value={emailInputValue}
                onChange={handleEmailChange}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
          {Error && <span className="text-danger">{Error}</span>}
          <div className="d-flex justify-content-end">
            <Button
              className="rounded-2 w-100"
              type="submit"
              disabled={emailUsers.length === 0 && emailInputValue.length === 0}
              variant="primary"
            >
              <span>Invite</span>
            </Button>
          </div>
        </Form>

        <ShareFooter
          handleCopyLink={handleCopyLink}
          handleFacebookShare={handleFacebookShare}
          handleWhatsappShare={handleWhatsappShare}
        />
      </div>
    </div>
  );
};

export default InviteToLookflock;
